import {apiUrl} from '../common/Globals';
import {stringify} from 'query-string';
import {GET_LIST, GET_ONE, UPDATE} from 'react-admin';

import {HTTP_GET, HTTP_POST} from '../common/HttpService';

const resourceBaseUlr = apiUrl + '/project/request';

const getProjectRequest = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const getProjectRequests = async (params) => {
  const {page, perPage} = params.pagination;
  const {field, order} = params.sort;

  const query = {
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    filter: JSON.stringify(params.filter)
  };
  const url = `${resourceBaseUlr}?${stringify(query)}`;

  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};
const updateProjectRequests = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  const body = params.data;
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};
const ProjectRequestsDataProvider = (type, resource, params) => {
  switch (type) {
    case GET_LIST:
      return getProjectRequests(params);

    case GET_ONE:
      return getProjectRequest(params);

    case UPDATE:
      return updateProjectRequests(params);

    default:
      return Promise.reject('Unknown Type');
  }
};

export default ProjectRequestsDataProvider;
